
import { supabase } from "@/integrations/supabase/client";
import { Screen } from "@/models/screen";

export const fetchScreens = async (): Promise<Screen[]> => {
  try {
    // Llamar a la función que actualiza espacios de anuncios vencidos
    console.log('Actualizando anuncios vencidos...');
    await updateExpiredAds();
    console.log('Anuncios vencidos actualizados, cargando datos actualizados de pantallas...');
    
    const { data: statsData, error: statsError } = await supabase
      .from('screen_stats')
      .select('*');
    
    if (statsError) {
      console.error('Error al cargar estadísticas de pantallas:', statsError);
      return [];
    }
    
    if (!statsData || statsData.length === 0) {
      const { data, error } = await supabase.from('screens').select('*');
      
      if (error) {
        console.error('Error al cargar pantallas:', error);
        return [];
      }
      
      if (!data) return [];
      
      const transformedScreens: Screen[] = data.map((screen) => ({
        id: screen.id,
        name: screen.name,
        location: screen.location || '',
        max_ads: screen.max_ads,
        occupied_spaces: screen.occupied_spaces || 0,
        available_spaces: screen.available_spaces || screen.max_ads,
        occupancy_rate: screen.occupancy_rate || 0,
        created_at: screen.created_at,
        // Add camelCase aliases
        totalSpaces: screen.max_ads,
        occupiedSpaces: screen.occupied_spaces || 0,
        availableSpaces: screen.available_spaces || screen.max_ads,
        occupancyRate: screen.occupancy_rate || 0
      }));
      return transformedScreens;
    }

    const transformedScreens: Screen[] = statsData.map(screen => {
      const availableSlots = screen.available_slots || 0;
      const occupiedSpaces = (screen.max_ads || 0) - availableSlots;
      const occupancyRate = screen.max_ads ? Math.round((occupiedSpaces / screen.max_ads) * 100) : 0;
      return {
        id: screen.id || '',
        name: screen.name || '',
        location: screen.location || '',
        max_ads: screen.max_ads || 0,
        occupied_spaces: occupiedSpaces,
        available_spaces: availableSlots,
        occupancy_rate: occupancyRate,
        created_at: screen.created_at || new Date().toISOString(),
        // Add camelCase aliases
        totalSpaces: screen.max_ads || 0,
        occupiedSpaces,
        availableSpaces: availableSlots,
        occupancyRate
      };
    });

    // Add this console log to debug what data we're getting from the database
    console.log('Screen data from database:', transformedScreens);

    if (transformedScreens.length > 0) {
      const screenIds = transformedScreens.map(s => s.id);
      const { data: screenDetails, error: detailsError } = await supabase
        .from('screens')
        .select('id, location')
        .in('id', screenIds);
      if (!detailsError && screenDetails) {
        transformedScreens.forEach(screen => {
          const details = screenDetails.find(d => d.id === screen.id);
          if (details) screen.location = details.location || '';
        });
      }
    }
    
    // Add this log to confirm the final data we're returning
    console.log('Final transformed screens data:', transformedScreens);
    
    return transformedScreens;
  } catch (err) {
    console.error('Error al cargar pantallas:', err);
    return [];
  }
};

// Función para llamar a la función de actualización de anuncios vencidos
async function updateExpiredAds() {
  try {
    // Llamar a la función RPC en Supabase para actualizar anuncios vencidos
    const { data, error } = await supabase.rpc('update_expired_ads');
    
    if (error) {
      console.error('Error al actualizar anuncios vencidos:', error);
      return;
    }
    
    console.log('Anuncios vencidos actualizados correctamente', data);
  } catch (error) {
    console.error('Error al actualizar anuncios vencidos:', error);
  }
}
